<div class="welcome-banner" [ngStyle]="{'background-image': 'url(' + bgImage + ')'}">
  <div class="welcome-banner-content">
    <div class="banner-logo">
      <img [src]="welcomeBannerData?.logoUrl" style="width: 14rem;" alt="">
    </div>
    <p class="banner-title banner-sub-title">{{getTransalatedValue(welcomeBannerData?.subTitle)}}</p>
    <h1 class="banner-title">{{getTransalatedValue(welcomeBannerData?.mainTitle)}}</h1>
    <p class="banner-text">{{getTransalatedValue(welcomeBannerData?.description)}}</p>
  </div>
</div>